<template>
  <div class="error-page">
    <img class="image" :src="`/not-found-404.svg`" />
    <div class="text text-not-found">{{ $t('src/pages/notfound.1659') }}</div>
    <button class="btn btn-lg btn-dark btn-block btn-come-back" type="submit" @click="goBack">
      {{ $t('button.home') }}
    </button>
  </div>
</template>

<script>
import('@/styles/components/error-page.less')

export default {
  name: 'NotFound',
  methods: {
    goBack() {
      this.$router.push('/')
    }
  }
}
</script>
